import { computed, ref } from "vue";

interface UseContactFormOptions {
    // hookUrl: string;
    privacyPolicyHidden: boolean;
    validationMessage: string;
    successMessage: string;
    errorMessage: string;
    pageUuid: string;
    sectionId: number;
}

const makeUrl = (pageUUID: string, sectionId: number) =>
    `${process.env.VUE_APP_ORIGIN}/api/pages/${pageUUID}/contact-form-handler/${sectionId}`;

export function useContactForm(options: UseContactFormOptions) {
    const agreed = ref(options.privacyPolicyHidden);
    const formSubmitted = ref(false);
    const isSubmitting = ref(false);
    const showSuccessMessage = ref(false);
    const errorMessage = ref("");
    const showErrorMessage = computed(() => Boolean(errorMessage.value));
    const ajaxURL = makeUrl(options.pageUuid, options.sectionId);

    const handleSubmit = async (e: SubmitEvent) => {
        e.preventDefault();
        formSubmitted.value = true;

        if (!agreed.value) {
            return;
        }

        const form = e.target as HTMLFormElement;
        isSubmitting.value = true;
        try {
            const response = await fetch(ajaxURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(Object.fromEntries(new FormData(form))),
            });
            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.message);
            }
            showSuccessMessage.value = true;
            form.reset();
        } catch (error) {
            if (error instanceof Error) {
                errorMessage.value = error.message;
            } else {
                errorMessage.value = "An unexpected error occurred.";
            }
            console.error("Failed to submit the form:", error);
        } finally {
            isSubmitting.value = false;
        }
    };

    return {
        agreed,
        formSubmitted,
        isSubmitting,
        showSuccessMessage,
        showErrorMessage,
        errorMessage,
        handleSubmit,
    };
}
